import { render, staticRenderFns } from "./ShowSundryItemPricePopUp.vue?vue&type=template&id=24b68d6e&scoped=true&"
import script from "./ShowSundryItemPricePopUp.vue?vue&type=script&lang=js&"
export * from "./ShowSundryItemPricePopUp.vue?vue&type=script&lang=js&"
import style0 from "./ShowSundryItemPricePopUp.vue?vue&type=style&index=0&id=24b68d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b68d6e",
  null
  
)

export default component.exports